import { render } from "./Dashboard.vue?vue&type=template&id=e760b508&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=e760b508&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e760b508"

export default script